exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.email-category-paginated-overview[data-v-b48790f4] {\n  min-height: 50px;\n}\n.email-category-paginated-overview .table[data-v-b48790f4] {\n  margin-bottom: 0;\n}\ntr th.half-padding[data-v-b48790f4] {\n  padding: 4px;\n}\n.padding-top-8[data-v-b48790f4] {\n  padding-top: 8px;\n}\ntr.selected[data-v-b48790f4] {\n  background-color: #1890ff1c;\n}\ntable th.compact[data-v-b48790f4], table td.compact[data-v-b48790f4] {\n  white-space: nowrap;\n  width: 1px !important;\n}\ntable > tbody.loading[data-v-b48790f4] {\n  opacity: 0.5;\n}\n.loading[data-v-b48790f4] {\n  opacity: 0.5;\n}\n", ""]);

// exports
